import { IPcr } from '../../../features/pcr/store/pcr.types'
import { IPatientVitals } from '../../../features/vitals/store/vitals.types'
import Logger from '../../../services/logger.service'
import { setValueForPathWithCreate } from '../../object.util'

export const addCustomVitals = (pcr: any): IPcr => {
  try {
    if (
      pcr.patient &&
      pcr.patient.patientVitals?.length &&
      pcr.patient.patientVitals[0].customVitalConfig === undefined &&
      pcr.patient.patientVitals[0].customVitalLabel1 === undefined &&
      pcr.patient.patientVitals[0].customVitalLabel2 === undefined
    ) {
      pcr.patient.patientVitals.forEach((vital: IPatientVitals) => {
        setValueForPathWithCreate(vital, 'customVitalConfig', null)
        setValueForPathWithCreate(vital, 'customVitalLabel1', '')
        setValueForPathWithCreate(vital, 'customVitalLabel2', '')
        setValueForPathWithCreate(vital, 'customVitalValue1', '')
        setValueForPathWithCreate(vital, 'customVitalValue2', '')
        setValueForPathWithCreate(vital, '__customVitalLabelExists', false)
      })
    }
    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addCustomVitals: ${error}`)
    throw error
  }
}
